import { z } from "zod";

/**
 * ライセンス追加画面のSearch Parameters
 */
export const SearchSchema = z.object({
  /** アプリケーション連携ID */
  appIntegrationId: z.string().optional(),
  /** ソフトウェアID */
  softwareId: z.string().optional(),
});

export type SearchParams = z.infer<typeof SearchSchema>;
